import { render } from "./cp_editContent.vue?vue&type=template&id=167ffa57&scoped=true"
import script from "./cp_editContent.vue?vue&type=script&lang=js"
export * from "./cp_editContent.vue?vue&type=script&lang=js"

import "./cp_editContent.vue?vue&type=style&index=0&id=167ffa57&scoped=scoped&lang=less"

import exportComponent from "E:\\Work\\Code\\HZY.Student\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167ffa57"]])

export default __exports__